<template>
  <div class="pc-search">
    <div class='search-tags'>
      <p class='search-tag' :class="item.name==selectedTag?'active':''" v-for='item in titles' :key="item.id" @click='changeTag(item)'>{{item.name}}</p>

    </div>
    <el-form class="pc-search-main-form" :model="keywords" :inline="true">
      <div class="line-one">
         <el-form-item label="标签主题" class="short-select">
          <el-select v-model="keywords.tag_id" placeholder="选择主题" clearable>
            <el-option
              :label="item.name +' ' + item.englishName"
              :value="item.id"
              v-for="item in $global.ENUM.URBANDREAMCARDS"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="类型" class="short-select">
          <el-select v-model="keywords.type" placeholder="选择类型" clearable >
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="item in typeList"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>

      <div class='line-one-city'>
           <el-form-item label="地点" class="short-select city-select">
          <el-select v-model="keywords.continent" placeholder="大洲" clearable @change='getCountryDicList()'>
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="item in continentList"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  class="short-select city-select">
          <el-select v-model="keywords.country" placeholder="国家"  clearable :disabled='!keywords.continent' @change='getCityDicList()'>
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="item in countryList"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>
           <el-form-item  class="short-select city-select">
          <el-select v-model="keywords.city_name" placeholder="城市"  clearable :disabled='!keywords.continent||!keywords.country '>
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="item in cityList"
              :key="item.index"
            ></el-option>
          </el-select>
        </el-form-item>

      </div>

      

     


      </div>
      <div class="line-two">
        <el-form-item label="关键词筛选" class="short-select">
          <el-input
            v-model="keywords.keyword"
            maxlength="60"
            placeholder="请输入关键词"
          ></el-input>
        </el-form-item>



        <el-form-item label="发布日期" class="createTime">
        <el-date-picker
          v-model="keywords.timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      </div>
      <button class="pc-search-clickBtn" @click.prevent="search">筛选</button>
    </el-form>
  </div>
</template>

<script>
import { getDictionaries,getCities } from "./regionList.gql";
export default {
  data() {
    return {
      selectedTag:'待审核',
      titles:[
      {
        name:"待审核",
        audit:0,
        status:null,
      },
       {
        name:"已通过",
        audit:1,
        status:1,
      },
       {
        name:"已删除",
        audit:null,
        status:0,
      },
       {
        name:"全部",
        audit:null,
        status:null,
      }],
      options: [],
      typeTagArgs: {
        skip: 0,
        type: "REGION",
        order: "+createTime",
      },
      keywords: {
        tag_id: null,
        type:null,
        continent:null,
        country:null,
        city_name: null,
        timeRange:null,
        keyword: null,
        start: null,
        end: null,
        page: null,
        audit:null,
        status:null,
      },

      typeList:[
        {name:'全部',
        value:null},
        {name:'问题',
        value:'question'},
        {name:'评论',
        value:'answer'}
      ],

      cityList:[],
      continentList: [],
      countryList: [],
    };
  },
  async created() {
    this.getContinentDicList("map_position");
  },
   watch: {
    'keywords.country': {
      handler: function () {
      if(!this.keywords.country){
        this.keywords.city_name = null
      }
      },
    },
    'keywords.continent': {
      handler: function () {
      if(!this.keywords.continent){
        this.keywords.city_name = null
        this.keywords.country = null
      }
      },
    }
  },
  methods: {
    changeTag(item){
      this.keywords.tag_id = null;
      this.keywords.keyword = null
      this.keywords.type = null;
      this.keywords.city_name = null;
      this.keywords.start = null;
      this.keywords.end = null;
      this.keywords.page = 1;
      this.selectedTag = item.name
      this.keywords.status= item.status
      this.keywords.audit= item.audit
      console.log(this.keywords)
      
      this.$emit("changeTag", this.keywords);
    },
    getContinentDicList(type) {
      this.$global
        .GraphqlQuery(this, getDictionaries, { type: type })
        .then((res) => {
          this.continentList = res.data;
          console.log(this.continentList);
        });
    },
    getCountryDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: ("map_position_" + this.keywords.continent)
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.countryList = res.data;
        });
    },
    getCityDicList(){
      this.$global
        .GraphqlQuery(this, getCities, {
          country:this.keywords.country
        })
        .then((res) => {
          this.cityList = res.data;
        });
    },

    search() {
      if(this.keywords.timeRange){
         this.keywords.start = this.$dtime(this.keywords.timeRange[0]).format("YYYY-MM-DD")
      this.keywords.end = this.$dtime(this.keywords.timeRange[1]).format("YYYY-MM-DD")

      }
     
      console.log(this.keywords)
      this.$emit("search", this.keywords);
    },
  },
};
</script>



<style lang="scss" scoped>
.search-tags{
  display: flex;
  margin-top:-20px;
  border-bottom:2px solid $indexHotLine;
  margin-bottom:33px;
  .search-tag{
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    margin-right:50px;
    cursor: pointer;
  }
  .active{
    color:$timeBtn;
    border-bottom:6px solid $timeBtn;
  }
}
.pc-search-main-form {
  position: relative;
  .line-one,
  .line-two {
    width: 90%;
    .line-one-city{
      display: inline-block;
    }
  }
  /deep/ .el-input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .el-form-item__label {
    font-family: $chinese;
    font-size: 16px;
    font-weight: bold;
    color: $mainTitle;
    width: 100px;
    margin-right: 40px;
  }
  /deep/ .long-select {
    width: 853px;
    .el-form-item__content {
      width: 710px;
      .el-input__inner {
        width: 100%;
      }
    }
  }
  /deep/ .el-range-separator{
    padding:0px;
  }
  /deep/ .short-select .el-input__inner {
    width: 280px;
  }
  /deep/ .city-select .el-input__inner {
    width: 118px;
  }
  // /deep/ .city-select .el-form-item__label{
  //   margin-right:10px;

  // }
  .pc-search-clickBtn {
    position: absolute;
    right: 0px;
    bottom: 20px;
    width: 90px;
    height: 40px;
    background: $blueBtn;
    border-radius: 4px;
    outline: none;
    border: none;
    font-family: $chinese;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/audit/urbanDream/Search.vue